import moment from 'moment';

import { DateFormat } from '../../../../../utils/date';
import { EM_DASH, isClientAudience } from '../../utils/constants';
import { formatAudience } from '../../utils/formatAudience';

const SUB_TABS = {
  OVERVIEW: 'overview',
  MESSAGE: 'message',
  FAILED: 'failed',
};

const formatStoredDate = (value) => {
  if (!value) return '';
  const source = typeof value.toDate === 'function' ? value.toDate() : value;
  const parsed = moment(source);
  return parsed.isValid() ? parsed.format(DateFormat.DEFAULT_DATE_FORMAT) : '';
};

const formatStoredDateRange = (startDate, endDate) => {
  const start = formatStoredDate(startDate);
  const end = formatStoredDate(endDate);
  if (start && end) return `${start} – ${end}`;
  return start || end || '';
};

const formatFilter = (filterSnapshot, { consentedLabel, allLabel }) => {
  if (!filterSnapshot) return EM_DASH;
  const audience = formatAudience(filterSnapshot);
  const range = formatStoredDateRange(filterSnapshot.startDate, filterSnapshot.endDate);
  const countries = Array.isArray(filterSnapshot.countries) && filterSnapshot.countries.length > 0
    ? filterSnapshot.countries.join('/')
    : null;
  const leadConsent = filterSnapshot.requireConsent ? consentedLabel : allLabel;
  const consent = isClientAudience(filterSnapshot.audienceType) ? null : leadConsent;
  return [audience, range, countries, consent].filter(Boolean).join(' · ') || EM_DASH;
};

export {
  SUB_TABS,
  formatFilter,
};
